import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=b8ce5192&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"
import style0 from "./IconBase.vue?vue&type=style&index=0&id=b8ce5192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce5192",
  null
  
)

export default component.exports